import * as React from 'react'

const Footer = () => {
    return (
        <div className="footer">Made with ❤️ by Aritro. 2022.</div>
    )
}

export default Footer